// extracted by mini-css-extract-plugin
export default {"component":"Question_component__2FIp-","tag":"Question_tag__eL1A0","question":"Question_question__EIWuE"};